import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSEO } from "@/lib/seo";

const H2 = ({ children }) => <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-white">{children}</h2>;
const P = ({ children }) => <p className="text-zinc-400 leading-relaxed mb-4">{children}</p>;

const CookiePolicy = () => {
  const navigate = useNavigate();
  useSEO({
    title: "Cookie Policy | BrandToBuilt",
    description: "What cookies and local storage BrandToBuilt uses, and how to control them.",
    path: "/cookies",
  });

  const resetConsent = () => {
    localStorage.removeItem("cookie_consent");
    window.location.reload();
  };

  return (
    <div className="pt-28 md:pt-36 pb-24 min-h-screen" data-testid="cookie-policy-page">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-zinc-400 hover:text-[#ccff00] transition-colors mb-8" data-testid="cookies-back">
          <ArrowLeft size={16} /> Back
        </button>
        <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl mb-4">Cookie Policy</h1>
        <p className="text-zinc-500 text-sm mb-10">Last updated: 31 August 2026</p>

        <H2>What are cookies</H2>
        <P>Cookies (and similar tech like local storage) are small pieces of data websites store in your browser to remember things between visits.</P>

        <H2>What we use</H2>
        <P>Your cookie preference itself is stored in your browser's local storage, not a tracking cookie. If you're an admin logging into our dashboard, your login session is also stored in local storage — this is essential for the admin area to work and isn't used for tracking.</P>
        <P>If you click "Accept" on our cookie banner, we turn on PostHog analytics, which helps us understand how visitors use the site (and may include anonymised session replay) so we can improve it. This only runs with your consent, and never runs if you choose "Necessary only".</P>
        <P>When you check out, Stripe (our payment processor) may set its own cookies on their checkout page — this is outside our control and governed by <a href="https://stripe.com/gb/privacy" target="_blank" rel="noopener noreferrer" className="text-[#ccff00] underline">Stripe's own privacy policy</a>.</P>

        <H2>Managing your preference</H2>
        <P>You can change your mind at any time.</P>
        <button onClick={resetConsent} className="rounded-full border border-white/20 text-white text-sm px-6 py-3 hover:bg-white/5 transition-colors" data-testid="cookies-reset-btn">
          Reset my cookie preference
        </button>

        <H2 className="mt-10">Who we are</H2>
        <P>BrandToBuilt is a trading name of Ainsleys Touch Ltd, a company registered in England and Wales (company number 17294211), registered office at 66 Paul Street, London, England, EC2A 4NA.</P>

        <H2 className="mt-10">Contact</H2>
        <P>Questions? Email us at <a href="mailto:hello@brandtobuilt.co.uk" className="text-[#ccff00] underline">hello@brandtobuilt.co.uk</a></P>
      </div>
    </div>
  );
};

export default CookiePolicy;
